import React, { Component } from 'react';
import { Table, Icon } from 'semantic-ui-react';
import _ from 'lodash';

import { tabColors } from './OrganicAdSorting';
import './OrganicPreviewList.css';

class OrganicPreviewList extends Component {
  state = {};

  rowSelect = (index, type, adId) => {
    this.props.openAccordion(index, type, adId);
  };

  render() {
    const organicList = _.reverse(
      _.sortBy([...this.props.organicList], 'scheduled')
    );
    if (organicList) {
      return (
        <div className="organic-preview-list">
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell className="row-type">
                  Ad Type
                </Table.HeaderCell>
                <Table.HeaderCell className="row-id">Ad Name</Table.HeaderCell>
                <Table.HeaderCell className="row-scheduled">
                  Scheduled
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {organicList.map((organic, index) => (
                <Table.Row
                  onClick={() =>
                    this.rowSelect(organic.index, organic.adType, organic.adId)
                  }
                  key={index + organic.adId}
                >
                  <Table.Cell
                    style={{
                      'background-color':
                        tabColors[organic.adType.toUpperCase()]
                    }}
                  >
                    {organic.adType}
                  </Table.Cell>
                  <Table.Cell>{organic.adName}</Table.Cell>
                  <Table.Cell>
                    {organic.scheduled}
                    {organic.scheduled === 'Publish' ? (
                      <Icon
                        className="published-dot"
                        name="circle"
                        color="red"
                        size="large"
                      />
                    ) : null}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      );
    }
    return null;
  }
}

export default OrganicPreviewList;



// WEBPACK FOOTER //
// ./src/screens/Organic/OrganicPreviewList.js